import { createContext, useContext, useMemo } from "react";
import { useGLTF } from "@react-three/drei";
import { useLoader } from "@react-three/fiber";
import { EXRLoader } from "three/examples/jsm/loaders/EXRLoader";

const DiamondAssetsContext = createContext();

export function DiamondAssetsProvider({ children }) {
  // useGLTF / useLoader cache by URL, so these load once and are reused.
  const model = useGLTF("/test1-transformed.glb");
  const texture = useLoader(EXRLoader, "output.exr");

  const value = useMemo(() => ({ model, texture }), [model, texture]);

  return (
    <DiamondAssetsContext.Provider value={value}>
      {children}
    </DiamondAssetsContext.Provider>
  );
}

export function useDiamondAssets() {
  return useContext(DiamondAssetsContext);
}

// Preload the model to ensure it's available
useGLTF.preload("/test1-transformed.glb");
